export default __webpack_public_path__ + "static/media/203-sahrawi-arab-democratic-republic.957da71a.svg";